import React, { lazy } from 'react';

const TableList = lazy( () => import( './components/TableList' ) );
const TableView = lazy( () => import( './components/TableView' ) );
const TableForm = lazy( () => import( './components/TableForm' ) );
const CompanyError = lazy( () => import( './components/CompanyError' ) );

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Gantry Studio',
        pattern: '/:companyId',
        render: ( props ) => <TableList { ...props }/>,
    },
    {
        title: 'View Table',
        pattern: '/:companyId/:tableId/view-table',
        render: ( props ) => <TableView { ...props }/>,
    },
    {
        title: 'Create Table',
        pattern: '/:companyId/tables/create-table',
        render: ( props ) => <TableForm { ...props }/>,
    },
    {
        title: 'Edit Table',
        pattern: '/:companyId/:tableId/edit-table',
        render: ( props ) => <TableForm { ...props }/>,
    },
    {
        title: 'Gantry Studio',
        pattern: '/',
        render: ( props ) => <CompanyError { ...props }/>,
    }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;
    if ( match && !match.render && typeof match.component !== 'undefined' ) {
        match.render = Bundle( match.component, match.props );
        action.ok();
    } else {
        action.ok();
    }
}
